import {PAYMENT_METHOD_PAY_ID} from "../constants";
import {getThemeColor} from "../../customHostConfigOnClient";
import {Tooltip} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PayToImage from "../../resource/figma-images/PayTo_wordmark-Black.png";
import React from "react";
import {PaymentOption, PaymentOptionImage, PaymentOptionText} from "../../components/PaymentMethod";


export const renderPayIdPaymentOption = ({ handlePaymentMethodChange, selectedPaymentMethod}) => {
  return <PaymentOption
    onClick={handlePaymentMethodChange(PAYMENT_METHOD_PAY_ID)}
    selected={selectedPaymentMethod === PAYMENT_METHOD_PAY_ID}
    borderColor={getThemeColor()}
  >
    <Tooltip enterTouchDelay={0} leaveTouchDelay={5000} title={
      <div style={{padding: '5px 0 5px 10px', fontSize: '14px', lineHeight: '1.5'}}>
        <div style={{color: 'black', fontWeight: 600}}>PayTo</div><br/>
        <div>Authorize payments directly from your banking account.</div><br/>
        <a
          href="https://oligo.com.au/payto-learnmore"
          target="_blank"
          rel="noopener noreferrer"
          style={{color: '#333', textDecoration: 'underline'}}
        >
          Learn more
        </a>
      </div>
    } slotProps={{
      popper: {
        sx: {
          '& .MuiTooltip-tooltip': {
            backgroundColor: '#F9F7FC', // your custom color
            border: '1px solid #DDD',
            color: '#333', // text color
          }
        }
      }
    }}>
      <InfoOutlinedIcon
        style={{
          position: 'absolute',
          top: 8,
          right: 5,
          fontSize: 20,
          color: '#747F94',
          cursor: 'pointer'
        }}
      />
    </Tooltip>
    <PaymentOptionImage src={PayToImage} />
    <PaymentOptionText>Pay by Bank</PaymentOptionText>
  </PaymentOption>
}
